import { useTheme, View } from "@tamagui/core";
import { useCallback } from "react";
import { StyledTextInput } from "./TextInput.shared";
import { jsx, jsxs } from "react/jsx-runtime";
const TextInput = StyledTextInput.styleable(({
  children,
  ...inProps
}, forwardedRef) => {
  const theme = useTheme(),
    {
      // some of destructed props are just to avoid passing them to ...rest because they are not in web.
      allowFontScaling,
      blurOnSubmit,
      caretHidden,
      clearButtonMode,
      clearTextOnFocus,
      contextMenuHidden,
      cursorColor,
      dataDetectorTypes,
      disableFullscreenUI,
      editable,
      enablesReturnKeyAutomatically,
      importantForAutofill,
      inlineImageLeft,
      inlineImagePadding,
      inputAccessoryViewID,
      keyboardAppearance,
      keyboardType,
      lineBreakStrategyIOS,
      maxFontSizeMultiplier,
      multiline,
      numberOfLines,
      onBlur,
      onChangeText,
      onContentSizeChange,
      onEndEditing,
      onFocus,
      onChange,
      onScroll,
      onSelectionChange,
      onSubmitEditing,
      passwordRules,
      placeholderTextColor = theme["text-discreet"].variable,
      rejectResponderTermination,
      returnKeyLabel,
      returnKeyType,
      scrollEnabled,
      secureTextEntry,
      selection,
      selectionColor,
      selectTextOnFocus,
      showSoftInputOnFocus,
      textBreakStrategy,
      textContentType,
      underlineColorAndroid,
      ...rest
    } = inProps,
    finalOnChange = useCallback(e => {
      e.nativeEvent.text = e.nativeEvent.data, onChange?.(e);
    }, [onChange]);
  return /* @__PURE__ */jsxs(View, {
    overflow: "visible",
    position: "relative",
    children: [/* @__PURE__ */jsx("style", {
      children: `
                .is_SunshineTextInput::placeholder {
                  color: ${placeholderTextColor};
                }
          `
    }), /* @__PURE__ */jsx(StyledTextInput, {
      animateOnly: ["background-color", "border-color", "box-shadow"],
      focusVisibleStyle: {
        boxShadow: `0 0 0 4px ${rest.state === "error" ? theme["textInput.shadow.error"].variable : theme["textInput.shadow.default"].variable}`
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      },
      onBlur,
      onChange: finalOnChange,
      onFocus,
      ref: forwardedRef,
      ...rest
    }), children]
  });
});
export { TextInput };
//# sourceMappingURL=TextInput.mjs.map
